import React, { FC } from 'react';
import { Button } from '../common/Button';
import { Typography } from '../common/Typography';
import { useGetManagedUsers } from '../user-management';
import { useLicenseAssignment } from './LicenseAssignmentContext';

export const ConfirmButton: FC = () => {
  const { assignLicense, assigningStatus } = useLicenseAssignment();
  const { status, data } = useGetManagedUsers();
  const noUsers = data?.length === 0;
  const usersLoading = status === 'loading';
  const assigning = assigningStatus === 'loading';

  const disabled = assigning || usersLoading || noUsers;
  return (
    <Button onClick={assignLicense} disabled={disabled}>
      <Typography>Confirm</Typography>
    </Button>
  );
};
